export enum UserRoles {
  OPERATOR = 0,
  SUBCONTRACTOR = 1,
  CLIENT = 2,
}
